import React, { useState } from 'react';
import CategoryDTO from '../../../lib/CategoryDTO';
import CategoryFilter from '../../molecules/categoryFilter';
import DocumentList from '../../molecules/documentList';
import AsyncLoader from '../../../../../../../../design/1/js/templates/molecules/async-loader';
import ResponseDTO from '../../../lib/ResponseDTO';
import DocumentDTO from '../../../lib/DocumentDTO';

interface Props {
    action: string;
}

const SharedDownload = ({
    action,
}: Props) => {
    const baseClassName = 'w-sharedDocumentDownload';

    const [selectedCategory, setSelectedCategory] = useState<CategoryDTO>(null);

    return (
        <div className={`${baseClassName}`}>
            <AsyncLoader action={action}>
                {(response: { documentData: ResponseDTO }) => {
                    if (response.documentData == null) {
                        return null;
                    }

                    const documents = Object.values(response.documentData.documents)
                        .sort((a: DocumentDTO, b: DocumentDTO) => new Date(b.date).getTime() - new Date(a.date).getTime()) as DocumentDTO[];
                    const categories = response.documentData?.categories as CategoryDTO[];

                    return (
                        <>
                            {categories.length > 0 &&
                                <CategoryFilter
                                    categories={categories}
                                    documents={documents}
                                    onSelectCategory={setSelectedCategory}
                                    selectedCategory={selectedCategory}
                                />
                            }
                            <DocumentList
                                documents={documents}
                                selectedCategory={categories.length > 0 ? selectedCategory : null}
                            />
                        </>
                    );
                }}
            </AsyncLoader>
        </div>
    );
};

export default SharedDownload;
